//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { swiper, swiperSlide, directive } from "vue-awesome-swiper";

export default{
  components: { awesomeSwiper: swiper,swiperSlide, directive },
  props: {
    gameType: {
      type: String,
      required: true
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      defaultSrc: require('../../../assets/image/common/loadingS.gif'),
      swiperOption4: {
        slidesPerView: 1.04,
        spaceBetween: 0,
        freeMode: true,
      },
      swiperOption: {
        slidesPerView: 1.04,
        spaceBetween: 0,
      },
    }
  },
  updated(){

  },
  created() {
  },
  methods: {
    getList3(list){
      let arr = [];
      let len = list.length;
      if(len <= 3){
        return [list]
      };

      for(let i =0; i< Math.ceil(len / 3); i++){
        let alin = list.slice(i * 3, (i + 1) * 3);
        arr.push(alin)
      };

      return arr;
    },
    getList(list){
      let arr = [];
      let len = list.length;
      if(len <= 6){
        return [list]
      };

      for(let i =0; i< Math.ceil(len / 6); i++){
        let alin = list.slice(i * 6, (i + 1) * 6);
        arr.push(alin)
      };

      return arr;
    },
    goMore(item){
      if(item.gameType === '1'){
        this.$router.push({ path: '/gamelobby/egame', query: { gameType: item.gameType}})
      }else if(item.gameType === '2'){
        this.$router.push({ path: '/gamelobby/live', query: { gameType: item.gameType} })
      }else if(item.gameType === '3'){
        this.$router.push({ path: '/gamelobby/sports', query: { gameType: item.gameType} })
      }else if(item.gameType === '4'){
        this.$router.push({ path: '/gamelobby/lottery', query: { gameType: item.gameType}})
      }else if(item.gameType === '5'){
        this.$router.push({ path: '/gamelobby/fish', query: { gameType: item.gameType}})
      }else if(item.gameType === '6'){
        this.$router.push({ path: '/gamelobby/chess',query: { gameType: item.gameType}})
      }else if(item.gameType === '7'){
        this.$router.push({ path: '/gamelobby/Classic', query: { gameType: item.gameType}})
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/build922/views/game/item/hot.vue